import { useEffect } from "react";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { currentDateStartTime, currentDateEndTime } from "../lib/functions";

/**
 * Hook to set a default date range in filters on mount
 * @param {Function} setFilters - Redux action dispatcher
 * @param {Object} filters - Current filter state
 * @param {String} defaultRange - "today" | "last7days" | "thisMonth"
 */
import { useSearchParams } from "react-router-dom";

export const useDefaultDateRange = (setFilters, filters, defaultRange = "today") => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams(); // ← add this

  useEffect(() => {
    // ← check URL params directly, not just Redux state
    const hasUrlDates = searchParams.get("dateFrom") && searchParams.get("dateTo");
    if (hasUrlDates) return; // URL params take priority
    
    if (filters.fromDate || filters.toDate) return; // already set

    let fromDate, toDate;
    const today = dayjs();

    switch (defaultRange) {
      case "last7days":
        fromDate = currentDateStartTime(today.subtract(6, "day"));
        toDate = currentDateEndTime(today);
        break;
      case "thisMonth":
        fromDate = currentDateStartTime(today.startOf("month"));
        toDate = currentDateEndTime(today.endOf("month"));
        break;
      case "today":
      default:
        fromDate = currentDateStartTime(today);
        toDate = currentDateEndTime(today);
        break;
    }

    dispatch(setFilters({ fromDate, toDate }));
  }, [dispatch, filters.fromDate, filters.toDate, setFilters, defaultRange]);
};
